import { render, staticRenderFns } from "./PromotionSettingDetail.vue?vue&type=template&id=251eb496&scoped=true"
import script from "./PromotionSettingDetail.vue?vue&type=script&lang=js"
export * from "./PromotionSettingDetail.vue?vue&type=script&lang=js"
import style0 from "./PromotionSettingDetail.vue?vue&type=style&index=0&id=251eb496&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251eb496",
  null
  
)

export default component.exports